import React from 'react'
import style from './MainBlock.module.css'
const MainBlock = () => {
  return (
    <div className={style.main}>
      <div className={`${'customContainer'} ${style.main_wrap}`}>
        <h2 className={style.main_title}>Repairs</h2>
        <p className={style.main_desc}>
          Enhance your property’s value and appearance with our expert repairs
        </p>
      </div>
    </div>
  )
}

export default MainBlock
